import React from 'react';
import { Link } from 'react-router-dom';
import FeatherIcon from './FeatherIcon';
import { PRODUCT_LINKS } from './ProductsMenu';
import { portalBase } from '../lib/api';
const Footer: React.FC = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  // A dark band in both themes, so it gets its own surface tokens rather than riding the
  // neutral ramp, which mirrors between light and dark.
  return (
    <footer className="bg-footer text-footer-fg py-12">
      <div className="container mx-auto px-6">
        {/* Two columns before four: at the md breakpoint four columns were 150px wide,
            narrower than the 199px unbreakable info@pawsitivefuture.org below. */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-10">
          <div>
            <div className="flex items-center mb-6">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center mr-3">
                <img src="https://res.cloudinary.com/brandpad/image/upload/c_scale,w_auto/v1756758236/33917/logo_4b765b0f" alt="Logo" className="ml-1" />
              </div>
              <span className="text-xl font-bold">Pawsitive Future</span>
            </div>
            <p className="mb-6">Creating a better future for underserved pets through community-powered solutions.</p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 rounded-full bg-footer-surface flex items-center justify-center">
                <FeatherIcon name="facebook" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-footer-surface flex items-center justify-center">
                <FeatherIcon name="instagram" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/" onClick={scrollToTop} className="hover:text-primary transition">Home</Link></li>
              <li><Link to="/voucher-program" className="hover:text-primary transition">Voucher Program</Link></li>
              {PRODUCT_LINKS.map(({ to, label }) => (
                <li key={to}><Link to={to} className="hover:text-primary transition">{label}</Link></li>
              ))}
              <li><Link to="/contact" className="hover:text-primary transition">Contact</Link></li>
              {/* A plain anchor, not a Link: the router owns no route for a file in public/. */}
              <li><a href="/docs/clinic-getting-paid.pdf" target="_blank" rel="noopener" className="hover:text-primary transition">For Veterinary Clinics (PDF)</a></li>
              <li><Link to="/sign-in" onClick={scrollToTop} className="hover:text-primary transition">Sign in</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Ways to Give</h4>
            <ul className="space-y-3">
              <li><Link to="/donate" onClick={scrollToTop} className="hover:text-primary transition">One-Time Donation</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">Contact Us</h4>
            <address className="not-italic break-words">
              <p className="mb-3">
                8605 Santa Monica Blvd PMB 707825<br />
                West Hollywood, CA 90069-4109
              </p>
              <p className="mb-3">info@pawsitivefuture.org</p>
              <p>(213) 729-1614</p>
            </address>
          </div>
        </div>

        <div className="border-t border-footer-line pt-8 flex flex-col md:flex-row justify-between items-center">
          <p>© 2025 The Pawsitive Future Foundation. All rights reserved.</p>
          <div className="flex space-x-6 mt-6 md:mt-0">
            <a href={`${portalBase}/privacy`} className="hover:text-primary transition">Privacy Policy</a>
            <a href={`${portalBase}/terms`} className="hover:text-primary transition">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;